import { ChangeDetectionStrategy, Component, input, output } from '@angular/core';
import { ButtonLibComponent } from '../../atoms/button/button.component';
import { ShimmerFragmentLibComponent } from '../loading/shimmer/fragment/shimmer-fragment.component';

@Component({
  selector: 'lib-error-and-retry',
  standalone: true,
  imports: [ButtonLibComponent, ShimmerFragmentLibComponent],
  templateUrl: './error-and-retry.component.html',
  styleUrls: ['./error-and-retry.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ErrorAndRetryComponent {
  errorMessage = input.required<string>();
  labelButton = input.required<string>();
  labelError = input.required<string>();
  isLoadingState = input.required<boolean>();
  retry = output<void>();
}
